module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I watched Steve Sayres walk into my office-warming party. Maybe he thought he was obliged, as senior partner of the firm I’d recently worked for, to pretend to wish me well. Maybe the sentiment was even sincere; after all, he’d gotten what he wanted. He’d turned my mentor, Doron White, against me. He’d gotten me fired a few months before my partnership vote.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Sayres looked around, a smile curling his lips. The Law Offices of Laura Di Palma were on a half-empty floor of a renovated box. I shared a waiting room and two secretaries with a five-person public-interest law firm whose partners were long-ago radicals and whose associates did just enough workers’ comp to keep solvent.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My office, across the hall from theirs, was large but ugly, with industrial carpets and leased wood veneer furniture. It had a view of traffic creeping toward the freeway from Market Street. It was many blocks from the financial-district suites White, Sayres & Speck occupied.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My conference table and desk were spread with trays of cheese and cold cuts and crudités; nothing fancy, nothing catered. The lawyers from across the hall were drinking so-so wine with good humor. They seemed pleased to have me as a neighbor.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They doubtless approved of my last client. Dan Crosetti had been a bellwether activist accused of shooting his best friend, who’d turned out to be an undercover FBI agent. I’d lost my job over that case.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Sayres had gone to Doron White, founding partner, previously my ally, and made his argument: I was doing pro bono work without the firm’s consent, Crosetti’s controversial politics might offend our corporate clients, and I had again placed the firm under the jeweler’s eye of publicity.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Doron had agreed.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’d made the firm a lot of money. I’d made the firm famous. But all it took was one refusal to back down, and I was out the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’d been forced to choose between what mattered and what looked good. I’d chosen not to become Steven Sayres.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Crossing my unimpressive new office, Sayres wore his smugness like an expensive coat. He was tall and stylishly fit, his emaciated body pumped with stringy muscle. His face was lightly tanned, with lines of harried ill temper etched around his eyes and into his forehead. His graying hair showed comb lines, as if he’d just left the sauna. His suit looked custom-made, his usual dark blue, with a wild print tie now that no other kind would do.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Hello, Laura.” He stopped farther from me than was strictly polite. I was glad.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Steve.” I kept my tone friendly, but I didn’t extend my hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I wondered if you’d open your own office. Frankly”—he glanced at my relatively ill-dressed neighbors, making lunch of cheese and cold cuts—“I couldn’t have given you much of a reference if you’d tried to join one of the big firms here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I felt a smile chill my face. “A reference from you would have been superfluous, Steve. Everyone here knows me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“That’s right.” He slid his hand into his suit pocket. “And everyone here knows how Doron died.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Doron White had suffered a series of anginas that severely damaged his heart. A late-night encounter with a friend of Crosetti’s—an encounter in my then-office—had triggered Doron’s final and fatal heart attack.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A group of beautifully outfitted people stepped into the room. They were White, Sayres clients, formerly my clients—bank vice presidents, mostly. One, in-house counsel for Graystone Federal, waved at me before smoothing her Lauren Bacall hair. The others looked around, showing their surprise. No expensive paintings here, no tree-sized arrangements of exotic flowers.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I watched Steve. A hot redness spread up his neck and over the slack skin of his jaw. Without motion or overt distress, he’d flamed into a fury. That’s how it had begun with Doron, a sudden flush betraying his anger.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The bank clients were upon us now, hand-shaking and well-wishing, smiling at Steve to show they approved of his magnanimous visit. Of course he’d known they’d come; of course he’d had to come, too. If I let him, he’d position himself as Daddy, looking in on his little girl. He’d minimize me because he hadn’t been able to sabotage me.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Steve was just blaming me for Doron’s death,” I said. “And because Doron and I were close, and I resent it, I’m about to ask Steve to leave.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Steve’s face drained of color. Behind me, conversations stopped. Two of Steve’s clients stepped back, as if my honesty might sully them.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“I don’t work for you anymore, Steve. I don’t have to play this game. If you want to insult me, do it out loud for everyone to hear. Don’t stand here looking like Lord Bountiful while you complain in my ear that you didn’t get a chance to blackball me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He looked at his clients, formerly my clients. His brows were pinched into a mask of pitying chagrin. He used that face in court whenever he could. The clients had seen it there. But they had their own versions of it. I was the rule-breaker here.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("That’s why I was on my own in an office unfashionably south of Market. That’s what Dan Crosetti had done for me. I blessed him silently as I said, “I asked you to leave. Play cute with your clients somewhere else.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Well”—a bank client turned the word into a hearty sigh—“actually, Steve, if you’ll let me walk you back, I should be moving on.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Steve continued looking sad and paternal. “Let me buy you lunch, Bill. Margaret, Harry, can you join us?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I took Harry’s hand and shook it. Did the same to Margaret’s. “Thank you so much for coming,” I said. “It was good to see you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Margaret stared at me, openmouthed. Bill put his hand on Steve’s arm. “Let’s try the new place around the corner. Maybe they can still seat four without a reservation.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Only Margaret seemed to hesitate, her skull-thin face crimped into a silent ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("But …")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" She finally joined the chorus of good-byes and good-lucks.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I watched two major banks and a mortgage brokerage walk out my door. They would spread the word, no doubt: Laura Di Palma was being hysterical. Maybe radical. She’d been gone almost ten months, no one was sure where, not practicing law, having some kind of mid-life crisis, probably. She hadn’t gone back to big-firm practice, she’d gone solo—and not even at a good address.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I turned to join the left-wing lawyers from across the hall. My practice, assuming I developed one in time to pay my lease and meet my small payroll, would not cut into Steve Sayres’s.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("That was fine with me.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You look like you could use a glass of wine. White or red?” Dennis Hyerdahl, known for some colorful conspiracy theories, circa 1968, handed me a plastic glass.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“White.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hyerdahl, slacks too low and tie too short over his middle-aged belly, poured the wine. One of the firm’s associates, a small blonde in a linty black suit, grinned.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“We’ve been looking forward to meeting you, to tell the truth.” Pat Frankel’s voice retained a hint of Larchmont, and her face was tanned almost to premature leatheriness. A sailor, probably. A preppy who’d taken a sharp turn left. “We heard you could be pretty, um, blunt.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’d gotten a lot of press defending a man who’d assassinated two United States senators. In the process of getting him acquitted, I’d developed a reputation for being aggressive. I supposed that was what she meant.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I took a quick swallow. “In my business dealings. When it’s appropriate.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hyerdahl laughed. “Blunt, I love it. God, yes, give me blunt.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Frankel elbowed him. “Diplomacy is hardly your problem.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Oh, Ms. Tactful here. Did I not hear you call your client a whiner this morning? Hmmm? Patricia?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A joking wince. “Her organization. Besides, she’s not my client.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Anymore, ha-ha.” He seemed to have no desire to follow up, to check up. If I’d had a boss like that, I wouldn’t be here now.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“You know, Laura”—Frankel’s eyes shined a manic blue—“I should refer her to you. If you do First Amendment stuff.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“Yes.” I do anything that pays the rent, right now. Anything that underwrites malpractice premiums and my share of Hyerdahl’s common-area expenses. Anything that pays for use of his law library and secretaries, his Xerox machines and voice mail. Even on the cheap, opening a practice had depleted my savings and exhausted my credit.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("“She actually has an interesting case.” Frankel leaned against the desk, coattails nudging the Brie. “I just got a little impatient with her. She’s part of a group I did some pro bono work for, but eons ago. She’s still back in the Call-Me-")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ms.")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("-Tibbs era of feminism, as if we haven’t moved way beyond— No, I should shut up and refer her to you, let you make up your own mind. I’ve definitely got baggage on this one.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In commercial practice, one did not acquire baggage. It was impossible to care that much about a bank.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I looked around my new office. It wasn’t the dramatic array of red leathers and accent pieces my last office had been. It lacked a view of flower vendors and street quartets and scrubbed stone highrises. But these people were across the hall now, not Steve Sayres. And I chose my own cases.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There were things I missed too much to think about. But those were the early days under Doron’s wing, when I’d been thrilled with the status and the responsibility. It had gone inalterably sour. That had happened to a lot of lawyers, except they remained in their purgatory of overwork and underappreciation.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Thank you, Dan Crosetti.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f3817b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FaceValue-2.vue
// module id = 72
// module chunks = 0